import { createStore, applyMiddleware } from "redux";
import { createBrowserHistory } from "history";
import { routerMiddleware } from "connected-react-router";
import { createEpicMiddleware } from "redux-observable";
import { composeWithDevTools } from "redux-devtools-extension";
import { loadUser, userFound } from "redux-oidc";
import rootEpic from "../epics/rootEpic";
import rootReducer from "../reducers/rootReducer";
import { userManagerFactory } from "../services/oidc/utils/userManager";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

const epicMiddleware = createEpicMiddleware();

export const history = createBrowserHistory();

// const loggerMiddleware = store => next => (action) => {
//   console.log('Action type:', action.type);
//   console.log('Action payload:', action.payload);
//   console.log('State before:', store.getState());
//   next(action);
//   console.log('State after:', store.getState());
// };

const persistConfig = {
  key: "root",
  storage,
  whitelist: [
    "getScoreCardsByType",
    "organizationInfo",
    "getScoringDecisionTemplate",
  ],
};

const persistedReducer = persistReducer(persistConfig, rootReducer(history));

export const store = createStore(
  persistedReducer,
  composeWithDevTools(
    applyMiddleware(epicMiddleware, routerMiddleware(history))
  )
);

export const persistor = persistStore(store);

const updateUser = (user) => {
  store.dispatch(userFound(user));
};

export { updateUser };

const configureStore = (apis) => {
  loadUser(store, userManagerFactory());
  epicMiddleware.run(rootEpic(apis));

  return store;
};

export default configureStore;



// WEBPACK FOOTER //
// ./src/store/configureStore.js